
import {translate} from '@elements/translations';
import {ref, watch, defineComponent} from 'vue';
import LoadingSpinner from '../../components/loading/LoadingSpinner.vue';
import ModalHeader from "./FullscreenModalHeader.vue";
import ModalFooter from "./FullscreenModalFooter.vue";


export default defineComponent({
    components: {
        ModalHeader,
        ModalFooter,
        LoadingSpinner
    },
    props: {
        config: {
            type: Object
        },
        stepViews: {
            type: Array,
            required: true
        },
        step: {
            type: Number,
            required: true
        },
        type: {
            type: String,
            required: false,
            default: "ticket"
        },
        buttonConfig: {
            type: Object,
            required: true
        },
    },
    emits: ["addToCart", "close"],
    setup(props, {emit}) {
        const showModal = ref(false);
        const modalRef = ref(null);
        const isLoading = ref<boolean>(true);

        const close = () => {
            showModal.value = false;
            emit('close');
            document.body.classList.remove('modal-open');
        };

        const show = (triggerTracking) => {
            showModal.value = true;
            isLoading.value = true;
            document.body.classList.add('modal-open');
            if (triggerTracking) {
                trackCartButtonClick();
            }
        };

        function trackCartButtonClick () {
            window.dataLayer.push({
                'event': 'click_product_teaser',
                'config_origin': 'ticket_configurator',
            })
        }

        return {
            modalRef,
            showModal,
            close,
            show,
            emit,
            translate,
            trackCartButtonClick,
        };
    },
});
